<div class="d-flex d-md-flex justify-content-between align-items-center m-b-10">
  <fui-heading [text]="'Moderate Posts'" [level]="5"></fui-heading>
</div>
<div class="row">
  <div class="col-md-12">
    <myp-segmented-bar
      #moderationSegmentedBar
      [white]="true"
      (selected)="switchModerationSection($event)"
      [options]="[
        {
          name: 'User Posts',
          id: 'posts',
          selected: true,
        },
        {
          name: 'Offending Users',
          id: 'offending_users',
        },
      ]"
    ></myp-segmented-bar>

    @if (selectedModerationSection == "posts") {
      <div>
        <div class="text-center m-y-20">Enter a user's ID to load a list of every post and reply they've authored.</div>
        <div class="product-filter m-b-20">
          <div class="filter-input">
            <input type="text" (keyup.enter)="loadPosts()" [(ngModel)]="userIdSearch" [placeholder]="'sphere.search' | translate" />
            @if (userIdSearch) {
              <div class="clear" (click)="clearModerateSearch()"><fa-icon icon="times"></fa-icon></div>
            }
          </div>
        </div>
        @if (moderatingUserNotFound) {
          <div class="text-center t-16 text-muted m-y-30">There is no user in Community with that ID.</div>
        }
        @if (moderatingUser) {
          <div class="text-center m-b-50">
            <img [src]="moderatingUser.photo ? moderatingUser.photo : './assets/images/default_avatar.jpg'" style="margin: auto" class="generic-profile-photo large" />
            <br />
            @if (moderatingUser.name) {
              <span class="t-18 bold d-block">{{ moderatingUser.name }}</span>
            }
            <span class="t-18 bold text-muted d-block">{{ moderatingUser.email }}</span>
            @if (moderatingUser.dateCommunityActivated) {
              <span class="t-16">Activated Community on {{ moderatingUser.dateCommunityActivated.toDate() | date }}</span>
            }
            @if (!moderatingUser.hasSetupCommunity) {
              <div>This user has not turned on their Community profile.</div>
            }
            @if (moderatingUser.hasSetupCommunity) {
              <div class="d-flex justify-content-center align-items-center m-y-20">
                <span class="t-12">Status: &nbsp;&nbsp;&nbsp;</span>
                <select (change)="statusDirty = true" [(ngModel)]="moderatingUser.status" class="form-control custom-select-sm m-r-10" style="width: 150px">
                  <option value="active">Active</option>
                  <option value="probation">Probation</option>
                  <option value="banned">Banned</option>
                </select>
                @if (statusDirty) {
                  <span class="btn btn-warning btn-sm" (click)="saveStatus()">Save</span>
                }
              </div>
            }
            <a class="btn btn-primary m-t-20" [href]="env.mypresonusUrl + '/profile/' + moderatingUser.id" target="_blank">View Profile</a>
          </div>
        }
        @if (userModerationResults && !userModerationResults.length) {
          <div class="text-center t-16 text-muted m-y-30">This user has not posted anything in Community yet.</div>
        }
        @for (hit of userModerationResults; track hit) {
          <div class="community-post">
            <div class="message-header">
              <img
                [routerLink]="['/profile', hit.author.id]"
                [src]="hit.author.id == user.id ? userService.profilePicture : hit.author.photo ? hit.author.photo : './assets/images/default_avatar.jpg'"
                class="profile-photo pointer"
              />
              <a class="t-18 bold pointer author-name m-l-40" [routerLink]="['/profile', hit.author.id]">{{ hit.author.name }}</a>
              <span class="time-created">{{ hit.created.toDate() | date: "MMM Do [at] h:mma" : true }}</span>
              <div class="channels">
                @if (hit.sphere_only && user.is_sphere_admin) {
                  <img src="./assets/icons/plus-icon-blue.png" class="circle-icon-btn m-r-15" placement="top" [ngbTooltip]="'Only shows in Studio One Pro+'" />
                }
                @if ((!hit.channels || !hit.channels.length) && (!hit.topics || !hit.topics.length)) {
                  <span class="channel" (click)="channelSelected.next('general')">
                    {{ "com.skills.general" | translate }}
                  </span>
                }
                @for (channel of hit.channels; track channel) {
                  @if (communityService.skillsMap[channel] || communityService.extraChannelsMap[channel]) {
                    <span class="channel" [class.disabled]="communityService.extraChannelsMap[channel] && !communityService.extraChannelsMap[channel].active" (click)="selectChannel(channel)">
                      #
                      {{
                        communityService.skillsMap[channel]
                          ? ("com.skills." + communityService.skillsMap[channel].string_id | translate)
                          : ("com.skills." + communityService.extraChannelsMap[channel].string_id | translate)
                      }}
                    </span>
                  }
                }
              </div>
            </div>
            <div class="msg">
              <span class="text main-post-text" [innerHTML]="hit.htmlMessage"></span>
            </div>
            <div class="search-result-actions">
              <div>
                @if (hit.parentID) {
                  <span class="action">This is a reply.</span>
                }
              </div>
              @if (hit.deleted) {
                <div>
                  @if (hit.deleted.admin) {
                    <span class="action red">Deleted by an Admin</span>
                  }
                  @if (!hit.deleted.admin) {
                    <span class="action red">Deleted by the author</span>
                  }
                </div>
              }
              <div>
                <span class="view-post" (click)="viewFullPost(hit)">
                  View Full Post
                  <fa-icon icon="chevron-right"></fa-icon>
                </span>
              </div>
            </div>
          </div>
        }
        @if (!allPostsGotten && userModerationResults && userModerationResults.length) {
          <button class="small-btn" (click)="loadMorePosts()">{{ "com.show_more_posts" | translate }}</button>
        }
      </div>
    }

    @if (selectedModerationSection == "offending_users") {
      <div style="max-width: 600px; margin: 30px auto">
        @for (user of offendingUsers; track user) {
          <myp-list-item
            [item]="user"
            [title]="user.name"
            [subData]="[user.status]"
            [photo]="user?.photo ? user.photo : './assets/images/default_avatar.jpg'"
            (itemClicked)="selectModeratedUser(user)"
          ></myp-list-item>
        }
      </div>
    }
  </div>
</div>
